export enum RefundTypeEnum {
    FULL = "FULL",
    PARTIAL = "PARTIAL"
}
